const getKey = (key) => (obj = {}) => obj[key];
const splitBy = (delimiter) => (str = '') => str.split(delimiter);
const mapFn = (fn) => (arr) => arr.map(fn);
const gte = (cmp) => (value) => cmp >= value;
const eq = (cmp) => (value) => cmp === value;
const not = (boolean) => !boolean;
const testPattern = (pattern) => (value) => pattern.test(value);
const includes = (value) => (exam = []) => exam.includes(value);
const inArray = (exam) => (value) => includes(value)(exam);
const byDefault = (defaultValue) => (value) => value === void 0 ? defaultValue : value;
const and = (...tests) => (value) => tests.every((test) => test(value));

export {
  and,
  gte,
  eq,
  not,
  mapFn,
  splitBy,
  getKey,
  testPattern,
  includes,
  inArray,
  byDefault,
  testPredicates,
}

function testPredicates(predicates, log = Function.prototype) {
  return (props) => predicates.some((test) => {
    const result = test(props);
    if (result) {
      log(result);
      return result;
    }
  });
}